import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { loginAdmin } from "../admin/api";
import { getAdminToken, setAdminToken } from "../admin/auth";

function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (getAdminToken()) {
    return <Navigate to="/" replace />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setError("");

    try {
      const result = await loginAdmin({ email, password });
      setAdminToken(result.token);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err.message || "Логин или пароль неверный");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="admin-page admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-card__header">
          <div className="admin-login-card__mark" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M5 20V9l7-5 7 5v11" />
              <path d="M9 20v-6h6v6M3 20h18" />
            </svg>
          </div>
          <div>
            <p className="admin-login-card__eyebrow">Lead3A</p>
            <h1>Вход в админку</h1>
            <p className="admin-login-card__subtitle">Авторизуйтесь для работы с базой жилых комплексов.</p>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="admin-form">
          <label>
            <span>Почта</span>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              autoComplete="username"
              placeholder="name@example.com"
              autoFocus
              required
            />
          </label>
          <label>
            <span>Пароль</span>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              autoComplete="current-password"
              placeholder="Введите пароль"
              required
            />
          </label>
          {error ? <p className="admin-error admin-login-card__error" role="alert">{error}</p> : null}
          <button className="admin-login-card__submit" type="submit" disabled={loading}>
            {loading ? "Выполняется вход..." : "Войти"}
          </button>
        </form>
        <Link className="admin-login-card__back" to="/">← Вернуться на карту</Link>
      </div>
    </main>
  );
}

export default AdminLoginPage;
